<template>
    <v-container fluid class="main-container responsive-height live-trade-detail-page"
        :class="{ 'live-trade-detail-page--dark': $vuetify.theme.dark }">
        <header class="detail-page-heading">
            <!-- <h1>Live Trade Details</h1> -->
            <div><span>Home</span><v-icon small>mdi-chevron-right</v-icon><span>Trading Details</span><v-icon small>mdi-chevron-right</v-icon><span>Live Trade Details</span></div>
        </header>
        <v-row dense>
            <v-col cols="12" xl="12">
                <v-card class="live-trade-details-card rounded-0" elevation="0"
                    :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
                    <v-row class="no-gutters">
                        <v-col cols="12" sm="6" md="6" lg="3">
                            <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" label="Search here ..."
                                single-line solo hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="2">
                            <v-select solo :items="allSymbols()" v-model="account" @input="accountFilter"
                                append-icon="mdi-chevron-down" label="Select Symbol" class="custom-select"></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-dialog ref="dialog" v-model="modal" :return-value.sync="dates" width="290px" class="">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field :value="dateRangeText" prepend-inner-icon="mdi-calendar"
                                        append-icon="mdi-chevron-down" readonly v-bind="attrs" v-on="on" solo
                                        class="custom-select"></v-text-field>
                                </template>
                                <v-date-picker v-model="dates" @input="dateFilter" class="custom-date-picker" scrollable
                                    range>
                                    <v-spacer></v-spacer>
                                    <v-btn :color="$vuetify.theme.dark
                                        ? '#ff567f'
                                        : '#ff567f'
                                        " text @click="cancelAction">
                                        Cancel
                                    </v-btn>
                                    <v-btn :color="$vuetify.theme.dark
                                        ? '#fff'
                                        : '#131c29'
                                        " text @click="$refs.dialog.save(dates)">
                                        OK
                                    </v-btn>
                                </v-date-picker>
                            </v-dialog>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="4">
                            <ul>
                                <li>
                                    <span>Total Equity:</span>
                                    <span>{{
                                        money(tradeSummary.Equity)
                                    }}</span>
                                </li>
                                <li>
                                    <span>Total Lot:</span>
                                    <span>{{
                                        money(tradeSummary.totalLot)
                                    }}</span>
                                </li>
                                <li>
                                    <span class="profit-loss">Profit / Loss:</span>
                                    <span>{{
                                        money(tradeSummary.profitLoss)
                                    }}</span>
                                </li>
                            </ul>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-card class="pa-3 rounded-0 elevation-0 mt-6" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'
                                ">
                                <v-sheet class="transactionTable liveTradeTable pb-3" :color="$vuetify.theme.dark
                                    ? '#1A2A3E '
                                    : '#F1F7FB'
                                    ">
                                    <v-data-table :headers="headers" :items="filteredData" :search="search"
                                        :items-per-page="6">
                                        <template v-slot:no-data>
                                            <div class="live-detail-empty">
                                                <v-icon size="48">mdi-briefcase-outline</v-icon>
                                                <strong>No live trades available</strong>
                                                <span>Open trading positions will appear here.</span>
                                            </div>
                                        </template>
                                        <template v-slot:item.serial="{ item, index }">
                                            <span>
                                                {{ index + 1 }}
                                            </span>
                                        </template>
                                        <template v-slot:item.TimeCreate="{ item }">
                                            <span>
                                                {{
                                                    formatMySQLDate(
                                                        item.TimeCreate
                                                    )
                                                }}
                                            </span>
                                        </template>
                                        <template v-slot:item.Action="{ item }">
                                            <span class="profit-text-color">
                                                {{
                                                    item.Action === 0
                                                        ? "Buy"
                                                        : item.Action === 1
                                                            ? "Sell"
                                                            : null
                                                }}
                                            </span>
                                        </template>
                                        <template v-slot:item.Volume="{ item }">
                                            <span class="profit-text-color">
                                                {{ item.Volume / 10000 }}
                                            </span>
                                        </template>
                                        <template v-slot:item.PriceOpen="{ item }">
                                            <span class="profit-text-color">
                                                {{
                                                    item?.PriceOpen?.toFixed(5)
                                                }}
                                            </span>
                                        </template>
                                        <template v-slot:item.PriceSL="{ item }">
                                            <span class="profit-text-color">
                                                {{ item?.PriceSL?.toFixed(2) }}
                                                -
                                                {{ item?.PriceTP?.toFixed(2) }}
                                            </span>
                                        </template>
                                    </v-data-table>
                                </v-sheet>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { TRADING__ACTIONS } from "@/store/action-types";

export default {
    data() {
        return {
            headers: [
                { text: "Sl", value: "serial", align: "start" },
                { text: "Ticket", value: "Position", align: "start" },
                {
                    text: "Date & Time",
                    value: "TimeCreate",
                },
                { text: "Type", value: "Action" },
                { text: "Lots", value: "Volume" },
                { text: "Symbol", value: "Symbol" },
                { text: "Open price", value: "PriceOpen" },
                { text: "SL-TP", value: "PriceSL" },
                { text: "Running", value: "PriceCurrent" },
                { text: "Profit", value: "Profit" },
            ],
            modal: false,
            search: "",
            account: "",
            dates: [],
            filteredData: [],
        };
    },

    computed: {
        ...mapState("trading", [
            "tradingAccountLiveTrades",
            "accountSpecificLiveTradesSummary",
        ]),
        dateRangeText() {
            return (this.dates.length === 2 ? [...this.dates].sort() : ["2022-01-01", this.getCurrentDate()]).join(" ~ ");
        },
        tradeSummary() {
            return this.accountSpecificLiveTradesSummary || {};
        },
    },
    methods: {
        money(value) {
            const amount = Number(value);
            return Number.isFinite(amount) ? amount.toFixed(2) : "0.00";
        },
        formatMySQLDate(mysqlDate) {
            

            // Ensure the input is in the correct format
            if (!mysqlDate) return "Invalid date";

            // Replace the "T" with a space to work with the current logic
            const isoFormattedDate = mysqlDate.replace('T', ' ').split('.')[0]; // Removes milliseconds
            const [datePart, timePart] = isoFormattedDate.split(' ');
            const [year, month, day] = datePart.split('-');
            const [hour, minute] = timePart.split(':');

            // Convert 24-hour time to 12-hour time
            const hour12 = hour % 12 || 12;
            const amPm = hour >= 12 ? 'pm' : 'am';

            // Return the formatted date and time
            return `${day}.${month}.${year} - ${hour12}:${minute} ${amPm}`;
        },
        getCurrentDate() {
            const currentDate = new Date();
            const formattedDate = currentDate.toISOString().split("T")[0];
            return formattedDate;
        },
        ...mapActions("trading", [TRADING__ACTIONS.CLIENTLIVETRADES]),
        allSymbols() {
            const symbols = this.tradingAccountLiveTrades.map(
                (acc) => acc.Symbol
            );
            return ["All", ...symbols];
        },

        dateFilter() {
            if (this.dates.length === 2) {
                let startDate = new Date(this.dates[0]);
                let endDate = new Date(this.dates[1]);

                if (startDate > endDate) {
                    [startDate, endDate] = [endDate, startDate];
                }

                // Increment the endDate by one day
                endDate.setDate(endDate.getDate() + 1);

                this.filteredData = this.tradingAccountLiveTrades.filter(
                    (item) => {
                        const tradeDate = new Date(
                            item.TimeCreate.split(" ")[0]
                        );
                        return tradeDate >= startDate && tradeDate <= endDate;
                    }
                );
            } else {
                this.filteredData = this.tradingAccountLiveTrades;
            }
        },

        accountFilter() {
            if (this.account === "All")
                return (this.filteredData = this.tradingAccountLiveTrades);
            this.filteredData = this.tradingAccountLiveTrades.filter(
                (item) =>
                    String(item.Symbol) === String(this.account)
            );
        },

        resetAll() {
            this.search = "";
            this.account = "";
            this.dates = [];
            this.filteredData = this.tradingAccountLiveTrades;
        },

        cancelAction() {
            this.modal = false;
            this.resetAll();
        },
    },
    async mounted() {
        await this[TRADING__ACTIONS.CLIENTLIVETRADES](this.$route.query.id);
        this.filteredData = this.tradingAccountLiveTrades;
        document.title = `Live Trade Details | ${this.accountSpecificLiveTradesSummary?.trading_account_no}`;
    },
};
</script>

<style scoped>
.live-trade-detail-page {
    --detail-page: #f7f8fa;
    --detail-panel: #ffffff;
    --detail-soft: #f4f5f7;
    --detail-field: #fbfaf6;
    --detail-border: #e0e3e7;
    --detail-text: #15181d;
    --detail-muted: #626973;
    --detail-gold: #d99a00;
    width: 100%;
    max-width: none;
    padding: 22px 24px 38px;
    color: var(--detail-text);
    background: var(--detail-page);
}

.live-trade-detail-page--dark {
    --detail-page: #030b13;
    --detail-panel: #07111b;
    --detail-soft: #101923;
    --detail-field: #08131e;
    --detail-border: #293026;
    --detail-text: #f5f7fc;
    --detail-muted: #aeb6c0;
    --detail-gold: #ffc400;
}

.detail-page-heading { margin-bottom: 18px; }
.detail-page-heading h1 { margin: 0 0 9px; color: var(--detail-text); font-size: 23px; }
.detail-page-heading > div { display: flex; align-items: center; gap: 8px; color: var(--detail-muted); font-size: 12px; }
.detail-page-heading .v-icon { color: var(--detail-muted); }
.detail-page-heading span:last-child { color: var(--detail-gold); }

.live-trade-detail-page .live-trade-details-card {
    padding: 14px;
    color: var(--detail-text) !important;
    background: var(--detail-panel) !important;
    border: 1px solid var(--detail-border);
    border-radius: 8px !important;
}

.live-trade-detail-page ::v-deep .live-trade-details-card .v-input.v-text-field--single-line {
    margin: 0 8px 0 0;
    background: transparent !important;
}

.live-trade-detail-page ::v-deep .live-trade-details-card .v-input__slot {
    min-height: 44px !important;
    color: var(--detail-text) !important;
    background: var(--detail-field) !important;
    border: 1px solid var(--detail-border);
    border-radius: 7px;
    box-shadow: none !important;
}

.live-trade-detail-page ::v-deep .live-trade-details-card input,
.live-trade-detail-page ::v-deep .live-trade-details-card .v-label,
.live-trade-detail-page ::v-deep .live-trade-details-card .v-select__selection { color: var(--detail-text) !important; }
.live-trade-detail-page ::v-deep .live-trade-details-card .v-input__prepend-inner .v-icon,
.live-trade-detail-page ::v-deep .live-trade-details-card .v-input__append-inner .v-icon { color: var(--detail-gold) !important; }

.live-trade-detail-page .live-trade-details-card ul {
    min-height: 44px;
    margin: 0;
    padding: 0 10px;
    align-items: center;
    background: var(--detail-soft);
    border: 1px solid var(--detail-border);
    border-radius: 7px;
}

.live-trade-detail-page .live-trade-details-card ul li span:first-child { color: var(--detail-muted); }
.live-trade-detail-page .live-trade-details-card ul li span:last-child { color: var(--detail-gold); }
.live-trade-detail-page .live-trade-details-card ul li .profit-loss,
.live-trade-detail-page .live-trade-details-card ul li .profit-loss + span { color: #ff4b55; }

.live-trade-detail-page ::v-deep .live-trade-details-card .v-card.mt-6,
.live-trade-detail-page ::v-deep .live-trade-details-card .transactionTable { margin-top: 12px !important; padding: 0 !important; background: var(--detail-panel) !important; }
.live-trade-detail-page ::v-deep .transactionTable { overflow: hidden; border: 1px solid var(--detail-border); border-radius: 7px; }
.live-trade-detail-page ::v-deep .v-data-table { color: var(--detail-text) !important; background: var(--detail-panel) !important; }
.live-trade-detail-page ::v-deep .v-data-table th { height: 40px; color: var(--detail-muted) !important; background: var(--detail-soft) !important; border-color: var(--detail-border) !important; font-size: 10px; }
.live-trade-detail-page ::v-deep .v-data-table td { height: 44px; padding: 0 10px !important; color: var(--detail-text) !important; border-color: var(--detail-border) !important; font-size: 11px; }
.live-trade-detail-page ::v-deep .v-data-table tbody tr:hover { background: rgba(217, 154, 0, .06) !important; }
.live-trade-detail-page ::v-deep .profit-text-color { color: var(--detail-gold) !important; }
.live-trade-detail-page ::v-deep .v-data-footer { color: var(--detail-muted); border-color: var(--detail-border) !important; }
.live-trade-detail-page ::v-deep .v-data-footer .v-icon { color: var(--detail-gold) !important; }

.live-detail-empty { display: flex; min-height: 150px; align-items: center; flex-direction: column; justify-content: center; gap: 6px; }
.live-detail-empty .v-icon { margin-bottom: 4px; color: var(--detail-gold); }
.live-detail-empty strong { color: var(--detail-text); font-size: 13px; }
.live-detail-empty span { color: var(--detail-muted); font-size: 11px; }

@media (max-width: 700px) {
    .live-trade-detail-page { padding: 14px 10px 28px; }
    .detail-page-heading h1 { font-size: 20px; }
    .detail-page-heading > div { flex-wrap: wrap; }
    .live-trade-detail-page .live-trade-details-card { padding: 10px; }
    .live-trade-detail-page .live-trade-details-card ul { margin-top: 8px; flex-wrap: wrap; gap: 12px; }
}
</style>
